// extracted by mini-css-extract-plugin
export default {"errors":"ErrorScreen_errors__jTolW","error":"ErrorScreen_error__Pg6sm"};